import { Outlet } from 'react-router-dom';
import Header from './Header';
import CTA from './CTA';
import Footer from './Footer';

export default function Layout() {
  return (
    <>
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <CTA />
      <Footer />
    </>
  );
}
